import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { GlobalVariable } from 'app/main/globals';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AspLoginService {
  paramData: any;


  constructor(
    private http: HttpClient, 
    private router: Router,
  ) { }

  getOTP(mobile) {
    this.paramData = {
      mobile: mobile,
      source: "web" 
      // device: `${GlobalVariable.DEVICE}`
    };
    
    // console.log('-----Request OTP-----------');
    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}` + '/login/v2/getOtp', this.paramData);
    
  }

  login(mobile, otp){
    this.paramData = {
      mobile: mobile,
      otp: otp,
      source: "web" 
    };
    // console.log(this.paramData);
    // console.log('-----Login-----------');    
    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}` + '/login/v2/validateOtp', this.paramData);
  }

  thisCheckLogin(){
    let spareLoginToken = localStorage.getItem('spareLoginToken');
    if(!spareLoginToken){
      this.router.navigate(['login']);
    }else{
      this.router.navigate(['home']);
    }
  }

  checkLogin(){
    let spareLoginToken = localStorage.getItem('spareLoginToken');
    if(!spareLoginToken){
      this.router.navigate(['login']);
    }
  }

  logout(){
    // Spares
    localStorage.removeItem('spareLoginToken');
    localStorage.removeItem('spareUserKey');
    localStorage.removeItem('selectedMake');
    localStorage.removeItem('selectedModel');
    localStorage.removeItem('selectedYear');
    localStorage.removeItem('variant');
    localStorage.removeItem('variantKey');
    localStorage.removeItem('rowKey');
    localStorage.removeItem('aspSpareAdded');
    localStorage.removeItem('spareRefreshToken');
    localStorage.removeItem('garageKey');
    localStorage.removeItem('zone');
    localStorage.removeItem('spareLoginNumber');
    localStorage.removeItem('spareSelectedGarageName');
    localStorage.removeItem('newMake');
    localStorage.removeItem('newModel');
    localStorage.removeItem('newYear');
    localStorage.removeItem('newVariant');
    localStorage.removeItem('newVariantKey');
    localStorage.removeItem('newRowKey');
    localStorage.removeItem('isShippingCharges');
    localStorage.removeItem('prepayUpiDiscount');
    localStorage.removeItem('selectedBrandImg');
    localStorage.removeItem('agentKey');
    localStorage.removeItem('rzp_device_id');
    localStorage.removeItem('rzp_checkout_anon_id');
    localStorage.removeItem('selectedBrand');
    localStorage.removeItem('userType');
    localStorage.removeItem('vehicleData');
    localStorage.removeItem('selectedSparesList');
    localStorage.removeItem('availableWalletBalance');
    localStorage.removeItem('contactName');
    localStorage.removeItem('contactEmail');
    localStorage.removeItem('contactPhone');
    localStorage.removeItem('fileName');
    localStorage.removeItem('roleType');
    localStorage.removeItem('userMobile');
    localStorage.removeItem('fuelType');
    localStorage.removeItem('isDynamicPopup');
    localStorage.removeItem('isFindMyCar');
    localStorage.removeItem('pageNumber');
    localStorage.removeItem('registrationNumber');
    localStorage.removeItem('selectedFuel');
    localStorage.removeItem('vin');
    localStorage.removeItem('sparePartsDetails');
    localStorage.removeItem('activeTab');
    localStorage.removeItem('requestedQuoteItems');
    localStorage.removeItem('spareGarageId');

    // -----------------------------------------------
    localStorage.removeItem('VariantKey');
    localStorage.removeItem('make');
    localStorage.removeItem('manufacturingYear');
    localStorage.removeItem('merchantId');
    localStorage.removeItem('model');
    localStorage.removeItem('notes');
    localStorage.removeItem('regNo');
    localStorage.removeItem('selectedJobCardStatus');
    localStorage.removeItem('selectedJobCardTime');
    localStorage.removeItem('vinNumber');
    localStorage.removeItem('year');
    localStorage.removeItem('spareUserKey');
    localStorage.removeItem('userType');
    localStorage.removeItem('roleType');
    localStorage.removeItem('spareLoginToken');
    localStorage.removeItem('spareRefreshToken');
    localStorage.removeItem('userMobile');
    localStorage.removeItem('agentKey');
    localStorage.removeItem('garageKey'); 
    localStorage.removeItem('zone');
    localStorage.removeItem('spareSelectedGarageName');
    localStorage.removeItem('spareSelectedGarageName');
    localStorage.removeItem('contactEmail');
    localStorage.removeItem('contactPhone');
    localStorage.removeItem('availableWalletBalance');
    localStorage.removeItem('selectedKits');
    localStorage.removeItem('bannerViewCount');
    localStorage.removeItem('megaSavingsPromptShown');
    localStorage.removeItem('addedCart');
    localStorage.removeItem('autoscoreValue');
    localStorage.removeItem('intantOrderPay');
    localStorage.removeItem('instantOrder');
    localStorage.removeItem('missingItemNames');
    localStorage.removeItem('addedRedeem');
    localStorage.removeItem('redeemCart');
    localStorage.removeItem('walletBalance');
    localStorage.removeItem('garages');
    localStorage.removeItem("isInsurance");
    localStorage.removeItem('insuranceGarageKey');
    localStorage.removeItem('addMoreItemsId');
    localStorage.removeItem('requestCartInfo');
    localStorage.removeItem('requestSummary');
    localStorage.removeItem('fromRequestPage');
    localStorage.removeItem('requestId');
    localStorage.removeItem('selectedRequestStatus');
    localStorage.removeItem('selectedRequestInsurance');
    localStorage.removeItem('selectedRequestTime');

    sessionStorage.clear();
    // End Spares

    this.router.navigate(['login']);
  }

}
